import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'

import { authConstants } from '../constants'

export function callLogin(payload) {
  return (dispatch) => {
    dispatch(doLogin())
    axios({
      method: 'POST',
      url: URIS.login,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        // console.log('ok', res)
        dispatch(doLoginSuccess(res.data))
      })
      .catch((error) => {
        if (error.response !== undefined) {
          dispatch(doLoginFailure(error.response.statusText))
        } else {
          dispatch(doLoginFailure(error.message))
        }
      })
  }
}

function doLogin() {
  return {
    type: authConstants.LOGIN
  }
}

export function doLoginSuccess(payload) {
  return {
    type: authConstants.LOGIN_SUCCESS,
    payload
  }
}

function doLoginFailure(payload) {
  return {
    type: authConstants.LOGIN_FAILURE,
    payload
  }
}

export function callLogout() {
  return {
    type: authConstants.LOGOUT
  }
}
